// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AssignmentToggleController from "./assignment_toggle_controller"
application.register("assignment-toggle", AssignmentToggleController)

import AutoHideController from "./auto_hide_controller"
application.register("auto-hide", AutoHideController)

import CustomerIndexController from "./customer_index_controller"
application.register("customer-index", CustomerIndexController)

import DaterangePickerController from "./daterange_picker_controller"
application.register("daterange-picker", DaterangePickerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import GroupManagementController from "./group_management_controller"
application.register("group-management", GroupManagementController)

import LucideController from "./lucide_controller"
application.register("lucide", LucideController)

import MultipleUploadController from "./multiple_upload_controller"
application.register("multiple-upload", MultipleUploadController)

import OrderCratesController from "./order_crates_controller"
application.register("order-crates", OrderCratesController)

import OrderIndexController from "./order_index_controller"
application.register("order-index", OrderIndexController)

import OrderTypeAutoSetController from "./order_type_auto_set_controller"
application.register("order-type-auto-set", OrderTypeAutoSetController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import TaskIndexController from "./task_index_controller"
application.register("task-index", TaskIndexController)

import ZipDownloadController from "./zip_download_controller"
application.register("zip-download", ZipDownloadController)
